import { Outlet, useOutletContext, useParams } from "react-router-dom";

import Alert from "../../../app/universalComponents/Alert";
import Loading from "../../../app/universalComponents/Loading";
import ErrorState from "../../../app/universalComponents/ErrorState";

import EventHeader from "./EventHeader";
import { useEventDetails } from "../dashboardApi";

export default function ActiveEvent() {
  const { eventSlug } = useParams();
  const { organiser, eventsList } = useOutletContext();

  const selectedEvent = eventsList.find((event) => event.slug === eventSlug);
  const activeEventId = selectedEvent?.id ?? null;

  const { data: activeEvent = null, isPending: activeEventPending, error: activeEventError } = useEventDetails(activeEventId);

  if (!selectedEvent) {
    return <ErrorState>Event not found.</ErrorState>;
  }

  if (activeEventPending) {
    return <Loading fullPage />;
  }

  if (activeEventError) {
    return <ErrorState>{activeEventError.message}</ErrorState>;
  }

  if (!activeEvent) {
    return <ErrorState>Event details could not be loaded.</ErrorState>;
  }

  return (
    <div className="flex min-h-dvh flex-col">
      {organiser?.status !== "active" && (
        <Alert tone="neutral" className="w-full text-center text-md">
          You'll need to activate your Stripe account before creating an event
        </Alert>
      )}

      <EventHeader activeEvent={activeEvent} />

      <main className="flex min-h-0 flex-1 flex-col overflow-auto">
        <Outlet context={{ activeEvent }} />
      </main>
    </div>
  );
}